/**
 * Feature flags that temporarily hide catalog surfaces.
 * Flip these back to true when the related provider/catalog is live again.
 */
export const SHOW_MOBILE_DATA = false;

/** Purchasing is paused. Checkout API code is in local-backups/ (gitignored). */
export const ADD_TO_CART_ENABLED = false;
export const CHECKOUT_ENABLED = false;
